import React, {useEffect, useReducer, useRef, useState} from "react";
import {IconButton, MenuItem, TextField, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {makeEnterpriseComponent} from "../util/utility";
import EventBus from "../util/EventBus";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../util/Buffer";
import {Backup, CloudUpload, KeyboardBackspace, TextSnippet} from "@mui/icons-material";
import css_buttons from "../../src/components/Common/css/CCButton.module.scss";
import {Grey6} from "../theme/styles";
import UploadSpreadsheet from "../components/Common/UploadSpreadsheet";
import spinner from "../assets/Spinner-1s-200px.svg";
import {v4 as uuidv4} from "uuid";
import CCButton from "../components/Common/CCButton";
import {SessionContext} from "../util/SessionContext";
import {S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";

type JobStep = {
    controls: any
}

interface State {
    steps: Array<JobStep>
}

interface Action {
    type: 'ADD'|'MARK_CURRENT'|'CONTROL_UPDATE';
    control: any | undefined;
    step: JobStep | undefined;
    stepIndex: number | undefined;
    formElementId: string | undefined;
}

export function stepReducer(state: State, action: Action) {
    switch (action.type) {
        case 'CONTROL_UPDATE': {
            let _state: State = structuredClone(state);
            _state.steps[action.stepIndex!].controls[action.formElementId!] = action.control;

            switch(action.formElementId) {
                // @ts-ignore
                case 'Type': {
                    _state.steps[action.stepIndex!].controls["SubType"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'SubType': {
                    _state.steps[action.stepIndex!].controls["Object"] = {
                        "value": "", valid: false
                    }
                    _state.steps[action.stepIndex!].controls["ExportType"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'Object': {
                    _state.steps[action.stepIndex!].controls["DocumentType"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'DocumentType': {
                    _state.steps[action.stepIndex!].controls["Form"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'Form': {
                    _state.steps[action.stepIndex!].controls["UploadSource"] = {
                        "value": "", valid: false
                    }
                    _state.steps[action.stepIndex!].controls["CalibrationDocumentType"] = {
                        "value": "", valid: false
                    }
                    _state.steps[action.stepIndex!].controls["ARDocumentType"] = {
                        "value": "", valid: false
                    }
                    _state.steps[action.stepIndex!].controls["ARForm"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'ARDocumentType': {
                    _state.steps[action.stepIndex!].controls["ARForm"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'ARForm': {
                    _state.steps[action.stepIndex!].controls["UploadSource"] = {
                        "value": "", valid: false
                    }
                }
                // @ts-ignore
                case 'CalibrationDocumentType': {
                    _state.steps[action.stepIndex!].controls["PreventativeMaintenanceDocumentType"] = {
                        "value": "", valid: false
                    }
                }
            }

            return _state;
        }
        default:
            return state;
    }
}

export default function NewJob() {
    const navigate = useNavigate();
    const [etlJobEnterpriseComponent] = useState(makeEnterpriseComponent("ETLJob"));
    const [documentTypeEnterpriseComponent] = useState(makeEnterpriseComponent("DocumentType"));
    const [documentTypeAREnterpriseComponent] = useState(makeEnterpriseComponent("DocumentType"));
    const [calibrationDocumentTypeEnterpriseComponent] = useState(makeEnterpriseComponent("DocumentType"));
    const [preventativeMaintenanceDocumentTypeEnterpriseComponent] = useState(makeEnterpriseComponent("DocumentType"));
    const [documentTypeFormEnterpriseComponent] = useState(makeEnterpriseComponent("DocumentTypeForm"));
    const [documentTypeARFormEnterpriseComponent] = useState(makeEnterpriseComponent("DocumentTypeForm"));
    const [documentTypeFetchBackgroundOperation, setDocumentTypeFetchBackgroundOperation] = useState(false);
    const [documentTypeARFetchBackgroundOperation, setDocumentTypeARFetchBackgroundOperation] = useState(false);
    const [calibrationDocumentTypeFetchBackgroundOperation, setCalibrationDocumentTypeFetchBackgroundOperation] = useState(false);
    const [preventativeMaintenanceDocumentTypeFetchBackgroundOperation, setPreventativeMaintenanceDocumentTypeFetchBackgroundOperation] = useState(false);
    const [documentTypeFormFetchBackgroundOperation, setDocumentTypeFormFetchBackgroundOperation] = useState(false);
    const [documentTypeARFormFetchBackgroundOperation, setDocumentTypeARFormFetchBackgroundOperation] = useState(false);
    const [saveBackgroundOperation, setSaveBackgroundOperation] = useState(false);
    const [documentTypeBuffer, setDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);
    const [documentTypeARBuffer, setDocumentTypeARBuffer] = React.useState<Map<string, any>[]>([]);
    const [calibrationDocumentTypeBuffer, setCalibrationDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);
    const [preventativeMaintenanceDocumentTypeBuffer, setPreventativeMaintenanceDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);
    const [formBuffer, setFormBuffer] = React.useState<Map<string, any>[]>([]);
    const [formBufferAR, setFormBufferAR] = React.useState<Map<string, any>[]>([]);
    const [showUploadSpreadsheet, setShowUploadSpreadsheet] = useState(false);
    const [jobUSID] = React.useState<string>(uuidv4());
    const [selectedFiles, setSelectedFiles] = useState([]);

    const [companyName, setCompanyName] = useState("");
    const [acronym, setAcronym] = useState("");
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [logoS3Key, setLogoS3Key] = useState("");
    const [logoUploadStatus, setLogoUploadStatus] = useState<'idle'|'uploading'|'done'|'error'>('idle');
    const [avatarFile, setAvatarFile] = useState<File | null>(null);
    const [avatarS3Key, setAvatarS3Key] = useState("");
    const [avatarUploadStatus, setAvatarUploadStatus] = useState<'idle'|'uploading'|'done'|'error'>('idle');

    const logoInputRef = useRef<HTMLInputElement>(null);
    const avatarInputRef = useRef<HTMLInputElement>(null);

    const [breadcrumb, setBreadcrumb] = useState<Map<string, string>>(new Map());

    const [transitions] = useState({
        "Type": {
            "Renderer": "renderType",
            "Import": "ImportSubType",
            "Export": "ExportSubType",
            "Execute": "ExecuteSubType"
        },
        "ImportSubType": {
            "Renderer": "renderImportSubType",
            "Import Enlil Object": "ImportEnlilObject",
            //"Import Content Into Lily": renderImportEnlilObject,
        },
        "ImportEnlilObject": {
            "Renderer": "renderImportEnlilObject",
            "EQUIPMENT": "DetermineImportObjectDocumentType",
            "EQUIPMENT_SPECIFICATION": "DetermineImportObjectDocumentType",
            "SUPPLIER": "DetermineImportObjectDocumentType",
            "CUSTOMERS": "DetermineImportObjectDocumentType",
            "RECORD": "DetermineImportObjectDocumentType",
            "PART": "DetermineImportObjectDocumentType",
            "PI": "DeterminePIImportObjectDocumentType",
        },
        "DeterminePIImportObjectDocumentType": {
            "Renderer": "renderDeterminePIImportObjectDocumentType",
            "ANY": "DetermineUploadSource"
        },
        "DetermineImportObjectDocumentType": {
            "Renderer": "renderDetermineImportObjectDocumentType",
            "ANY": "DetermineImportDocumentTypeForm"
        },
        "DetermineImportDocumentTypeForm": {
            "Renderer": "renderDetermineImportDocumentTypeForm",
            "ANY": "DetermineUploadSource"
        },
        "DetermineARImportObjectDocumentType": {
            "Renderer": "renderDetermineARImportObjectDocumentType",
            "ANY": "DetermineARImportDocumentTypeForm"
        },
        "DetermineARImportDocumentTypeForm": {
            "Renderer": "renderDetermineARImportDocumentTypeForm",
            "ANY": "DetermineUploadSource"
        },
        "DetermineUploadSource": {
            "Renderer": "renderSelectUploadSource",
            "LOCAL_DISK": "UploadSpreadsheetFromLocalDisk"
        },
        "UploadSpreadsheetFromLocalDisk": {
            "Renderer": "renderUploadSpreadsheetFromLocalDisk",
            "True": "CreateJobButtons"
        },
        "CreateJobButtons": {
            "Renderer": "renderImport_ImportEnlilObject_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons",
        },

        "ExportSubType": {
            "Renderer": "renderExportSubType",
            "Export Enlil Object(s)": "ExportEnlilObject",
            "Export Enlil Template": "Export_ExportEnlilTemplate"
        },
        "ExecuteSubType": {
            "Renderer": "renderExecuteSubType",
            "Enlil Service": "ExecuteEnlilService"
        },
        "ExecuteEnlilService": {
            "Renderer": "renderExecuteEnlilService",
            "Company Duplication": "ExecuteCompanyDuplication"
        },
        "ExecuteCompanyDuplication": {
            "Renderer": "renderExecuteCompanyDuplication",
        },
        "ExportEnlilObject": {
            "Renderer": "renderExportEnlilObject",
            "EQUIPMENT": "SelectEquipmentDownloadVolume"
        },
        "Export_ExportEnlilTemplate": {
            "Renderer": "renderExport_ExportEnlilTemplate",
            "EQUIPMENT": "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType",
            "EQUIPMENT_SPECIFICATION": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
            "SUPPLIER": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
            "CUSTOMERS": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
            "RECORD": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
            "PI": "Export_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType",
            "PART": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
        },

        "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType",
            "ANY": "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm"
        },
        "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm",
            "ANY": "Export_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType"
        },
        "Export_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType",
            "ANY": "Export_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType"
        },
        "Export_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType",
            "ANY": "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons"
        },
        "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons",
        },
        "Export_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType",
            "ANY": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons"
        },


        "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType",
            "ANY": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm"
        },
        "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm",
            "ANY": "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons"
        },
        "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons": {
            "Renderer": "renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons",
        },

        "SelectEquipmentDownloadVolume": {
            "Renderer": "renderSelectEquipmentDownloadVolume",
            "Equipment Template": "renderEquipmentTemplate",
            "1+ Equipment Volume": "render1PlusEquipmentVolume",
            "All Equipment Volume": "renderAllEquipmentVolume",
        },
    });

    const [state, dispatch] = useReducer(stepReducer, {
        steps: [{
            controls: {
                "Name": {"value": ""},
                "Type": {"value": ""},
                "SubType": {"value": ""},
                "Object": {"value": ""},
                "DocumentType": {"value": ""},
                "ARDocumentType": {"value": ""},
                "Form": {"value": ""},
                "ARForm": {"value": ""},
                "CalibrationDocumentType": {"value": ""},
                "PreventativeMaintenanceDocumentType": {"value": ""},
                "ExportType": {"value": ""},
                "UploadSource": {"value": ""},
                "DownloadVolume": {"value": ""},
            }
        }]
    });

    useEffect(() => {
        EventBus.components.addListener("upload-spreadsheet-cancel", onCancelHandler);
        EventBus.components.addListener("upload-spreadsheet-done", onUploadSpreadSheetSelection);

        documentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        documentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        documentTypeFormEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        documentTypeFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        documentTypeAREnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        documentTypeAREnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        documentTypeARFormEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        documentTypeARFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        calibrationDocumentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        calibrationDocumentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        preventativeMaintenanceDocumentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        preventativeMaintenanceDocumentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        return () => {
            EventBus.components.removeListener("upload-spreadsheet-cancel", onCancelHandler);
            EventBus.components.removeListener("upload-spreadsheet-done", onUploadSpreadSheetSelection);

            documentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            documentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            documentTypeFormEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            documentTypeFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)

            documentTypeAREnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            documentTypeAREnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            documentTypeARFormEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            documentTypeARFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)

            calibrationDocumentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            calibrationDocumentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
            preventativeMaintenanceDocumentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener)
            preventativeMaintenanceDocumentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener)
        }
    }, [documentTypeEnterpriseComponent, documentTypeAREnterpriseComponent]);

    function changeHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, formElementId: string, directive: string) {
        const updatedFormElement = {
            value: event.target.value,
            touched: true,
            valid: true,
            helperText: null,
        };

        let b = breadcrumb
        b.set(directive, event.target.value)
        setBreadcrumb(b)

        dispatch({type: "CONTROL_UPDATE", stepIndex: 0, control: updatedFormElement, formElementId: formElementId, step: undefined});

        if (formElementId === "Object" && directive !== "ExecuteEnlilService") {
            documentTypeEnterpriseComponent.newQuery();
            documentTypeEnterpriseComponent.setAttributeValue("Group", event.target.value);
            documentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
            documentTypeEnterpriseComponent.executeQuery(1, 5);
        }
        if (formElementId === "Form" && breadcrumb.get("ImportEnlilObject") === "PART") {
            documentTypeAREnterpriseComponent.newQuery();
            documentTypeAREnterpriseComponent.setAttributeValue("Group", "CHANGE_REQUEST");
            documentTypeAREnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
            documentTypeAREnterpriseComponent.executeQuery(1, 5);
        }
        if (formElementId === "Form" && breadcrumb.get("ImportEnlilObject") === "EQUIPMENT_SPECIFICATION") {
            documentTypeAREnterpriseComponent.newQuery();
            documentTypeAREnterpriseComponent.setAttributeValue("Group", "CHANGE_REQUEST");
            documentTypeAREnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
            documentTypeAREnterpriseComponent.executeQuery(1, 5);
        }
    }

    function cancelHandler() {
        navigate("/jobs");
    }

    function onUploadSpreadSheetSelection(args: any) {
        setSelectedFiles(args)
        setShowUploadSpreadsheet(false);
    }

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
        if (ec.serialNumber === documentTypeEnterpriseComponent.serialNumber) {
            setDocumentTypeFetchBackgroundOperation(true)
        }
        if (ec.serialNumber === documentTypeFormEnterpriseComponent.serialNumber) {
            setDocumentTypeFormFetchBackgroundOperation(true)
        }
        if (ec.serialNumber === documentTypeAREnterpriseComponent.serialNumber) {
            setDocumentTypeARFetchBackgroundOperation(true)
        }
        if (ec.serialNumber === documentTypeARFormEnterpriseComponent.serialNumber) {
            setDocumentTypeARFormFetchBackgroundOperation(true)
        }
        if (ec.serialNumber === calibrationDocumentTypeEnterpriseComponent.serialNumber) {
            setCalibrationDocumentTypeFetchBackgroundOperation(true)
        }
        if (ec.serialNumber === preventativeMaintenanceDocumentTypeEnterpriseComponent.serialNumber) {
            setPreventativeMaintenanceDocumentTypeFetchBackgroundOperation(true)
        }
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)

        if (ec.serialNumber === documentTypeEnterpriseComponent.serialNumber) {
            setDocumentTypeBuffer(b);
            setDocumentTypeFetchBackgroundOperation(false)
        }
        if (ec.serialNumber === documentTypeFormEnterpriseComponent.serialNumber) {
            setFormBuffer(b);
            setDocumentTypeFormFetchBackgroundOperation(false)
        }
        if (ec.serialNumber === documentTypeAREnterpriseComponent.serialNumber) {
            setDocumentTypeARBuffer(b);
            setDocumentTypeARFetchBackgroundOperation(false)
        }
        if (ec.serialNumber === documentTypeARFormEnterpriseComponent.serialNumber) {
            setFormBufferAR(b);
            setDocumentTypeARFormFetchBackgroundOperation(false)
        }
        if (ec.serialNumber === calibrationDocumentTypeEnterpriseComponent.serialNumber) {
            setCalibrationDocumentTypeBuffer(b);
            setCalibrationDocumentTypeFetchBackgroundOperation(false)
        }
        if (ec.serialNumber === preventativeMaintenanceDocumentTypeEnterpriseComponent.serialNumber) {
            setPreventativeMaintenanceDocumentTypeBuffer(b);
            setPreventativeMaintenanceDocumentTypeFetchBackgroundOperation(false)
        }
    }

    function onCancelHandler() {
        setShowUploadSpreadsheet(false);
    }

    // Export/Export Enlil Template
    function renderExportSubType() {
        let subTypeOptions = [
            "Export Enlil Template"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="SubType"
                        margin="dense"
                        fullWidth={true}
                        id="SubType"
                        label="Sub Type *"
                        onChange={(event) => changeHandler(event, "SubType", "ExportSubType")}
                        value={state.steps[0].controls["SubType"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ExportSubType", state.steps[0].controls["SubType"].value)}
            </>
        )
    }

    // Export/Export Enlil Template/Equipment Document Type/Equipment Document Form/CreateJobButtons

    function renderExport_ExportEnlilTemplate() {
        let subTypeOptions = [
            "Customer",
            "Equipment",
            "Equipment Specification",
            "Manufacturing Process Instruction",
            "Supplier",
            "Record",
            "Part",
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="Object"
                        margin="dense"
                        fullWidth={true}
                        id="Object"
                        label="Object *"
                        onChange={(event) => changeHandler(event, "Object", "Export_ExportEnlilTemplate")}
                        value={state.steps[0].controls["Object"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option.toUpperCase() === 'MANUFACTURING PROCESS INSTRUCTION' ? 'PI' : option.toUpperCase() === 'CUSTOMER' ? 'CUSTOMERS' : option.toUpperCase() === 'EQUIPMENT SPECIFICATION' ? 'EQUIPMENT_SPECIFICATION' : option.toUpperCase() }>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("Export_ExportEnlilTemplate", state.steps[0].controls["Object"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="DocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="DocumentType"
                            label="Object Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "DocumentType", "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType");

                                documentTypeFormEnterpriseComponent.newQuery();
                                documentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["DocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType", state.steps[0].controls["DocumentType"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="Form"
                            margin="dense"
                            fullWidth={true}
                            id="Form"
                            label="Form *"
                            onChange={(event) => {
                                changeHandler(event, "Form", "Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm")

                                calibrationDocumentTypeEnterpriseComponent.newQuery();
                                calibrationDocumentTypeEnterpriseComponent.setAttributeValue("Group", "MAINTENANCE_RECORD");
                                calibrationDocumentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
                                calibrationDocumentTypeEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["Form"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {formBuffer.map((element: any) => (
                                <MenuItem key={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID} value={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID}>
                                    {`${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DocumentID} Rev ${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DisplayRevision}`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm", state.steps[0].controls["Form"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {calibrationDocumentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="CalibrationDocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="CalibrationDocumentType"
                            label="Calibration Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "CalibrationDocumentType", "Export_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType");

                                preventativeMaintenanceDocumentTypeEnterpriseComponent.newQuery();
                                preventativeMaintenanceDocumentTypeEnterpriseComponent.setAttributeValue("Group", "MAINTENANCE_RECORD");
                                preventativeMaintenanceDocumentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
                                preventativeMaintenanceDocumentTypeEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["CalibrationDocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {calibrationDocumentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType", state.steps[0].controls["CalibrationDocumentType"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {preventativeMaintenanceDocumentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="PreventativeMaintenanceDocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="PreventativeMaintenanceDocumentType"
                            label="Preventative Maintenance Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "PreventativeMaintenanceDocumentType", "Export_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType");
                            }}
                            value={state.steps[0].controls["PreventativeMaintenanceDocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {preventativeMaintenanceDocumentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType", state.steps[0].controls["PreventativeMaintenanceDocumentType"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons() {
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "0px 20px 20px 20px"}}>
                <div style={{marginRight: "20px"}}>
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={() => cancelHandler()}>
                        Cancel
                    </CCButton>
                </div>
                <div style={{marginRight: "10px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        animate={saveBackgroundOperation}
                        onClick={() => saveExportEquipmentTemplateHandler("Save")}>
                        Save
                    </CCButton>
                </div>
                <CCButton
                    className={css_buttons.blueStandardButton}
                    animate={saveBackgroundOperation}
                        onClick={() => saveExportEquipmentTemplateHandler("Execute")}>
                    Save & Execute
                </CCButton>
            </div>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="DocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="DocumentType"
                            label="Object Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "DocumentType", "Export_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType");

                                documentTypeFormEnterpriseComponent.newQuery();
                                documentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["DocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType", state.steps[0].controls["DocumentType"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="DocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="DocumentType"
                            label="Object Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "DocumentType", "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType");

                                documentTypeFormEnterpriseComponent.newQuery();
                                documentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["DocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType", state.steps[0].controls["DocumentType"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="Form"
                            margin="dense"
                            fullWidth={true}
                            id="Form"
                            label="Form *"
                            onChange={(event) => {
                                changeHandler(event, "Form", "Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm")
                            }}
                            value={state.steps[0].controls["Form"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {formBuffer.map((element: any) => {
                                const formTemplate = element.get("ListOfFormTemplate")?.FormTemplate;

                                return formTemplate && formTemplate.length > 0 ? (
                                    <MenuItem
                                        key={formTemplate[0].DocumentRevisionUSID}
                                        value={formTemplate[0].DocumentRevisionUSID}
                                    >
                                        {`${formTemplate[0].DocumentRevision.DocumentID} Rev ${formTemplate[0].DocumentRevision.DisplayRevision}`}
                                    </MenuItem>
                                ) : null;
                            })}
                        </TextField>
                    )}
                </div>
                {renderTransition("Export_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm", state.steps[0].controls["Form"].value)}
            </>
        )
    }

    function renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons() {
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "0px 20px 20px 20px"}}>
                <div style={{marginRight: "20px"}}>
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={() => cancelHandler()}>
                        Cancel
                    </CCButton>
                </div>
                <div style={{marginRight: "10px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        animate={saveBackgroundOperation}
                        onClick={() => saveExportTemplateHandler("Save")}>
                        Save
                    </CCButton>
                </div>
                <CCButton
                    className={css_buttons.blueStandardButton}
                    animate={saveBackgroundOperation}
                        onClick={() => saveExportTemplateHandler("Execute")}>
                    Save & Execute
                </CCButton>
            </div>
        )
    }

    function renderExportEnlilObject() {
        let subTypeOptions = [
            "Customer",
            "Equipment",
            "Equipment Specification",
            "Manufacturing Process Instruction",
            "Part",
            "Record",
            "Supplier",
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="Object"
                        margin="dense"
                        fullWidth={true}
                        id="Object"
                        label="Object *"
                        onChange={(event) => changeHandler(event, "Object", "ExportEnlilObject")}
                        value={state.steps[0].controls["Object"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option.toUpperCase()}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ExportEnlilObject", state.steps[0].controls["Object"].value)}
            </>
        )
    }



    function renderImportSubType() {
        let subTypeOptions = [
            "Import Enlil Object"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="SubType"
                        margin="dense"
                        fullWidth={true}
                        id="SubType"
                        label="Sub Type *"
                        onChange={(event) => changeHandler(event, "SubType", "ImportSubType")}
                        value={state.steps[0].controls["SubType"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ImportSubType", state.steps[0].controls["SubType"].value)}
            </>
        )
    }

    function renderImportEnlilObject() {
        let subTypeOptions = [
            "Customer",
            "Equipment",
            "Equipment Specification",
            "Manufacturing Process Instruction",
            "Supplier",
            "Record",
            "Part"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="Object"
                        margin="dense"
                        fullWidth={true}
                        id="Object"
                        label="Object *"
                        onChange={(event) => changeHandler(event, "Object", "ImportEnlilObject")}
                        value={state.steps[0].controls["Object"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option.toUpperCase() === 'MANUFACTURING PROCESS INSTRUCTION' ? 'PI' : option.toUpperCase() === 'CUSTOMER' ? 'CUSTOMERS' : option.toUpperCase() === 'EQUIPMENT SPECIFICATION' ? 'EQUIPMENT_SPECIFICATION' : option.toUpperCase() }>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ImportEnlilObject", state.steps[0].controls["Object"].value)}
            </>
        )
    }

    function renderDetermineImportObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="DocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="DocumentType"
                            label="Object Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "DocumentType", "DetermineImportObjectDocumentType");

                                documentTypeFormEnterpriseComponent.newQuery();
                                documentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["DocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("DetermineImportObjectDocumentType", state.steps[0].controls["DocumentType"].value)}
            </>
        )
    }

    function renderDetermineARImportObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeARFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="ARDocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="ARDocumentType"
                            label="AR Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "ARDocumentType", "DetermineARImportObjectDocumentType");

                                documentTypeARFormEnterpriseComponent.newQuery();
                                documentTypeARFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeARFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeARFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["ARDocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeARBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("DetermineARImportObjectDocumentType", state.steps[0].controls["ARDocumentType"].value)}
            </>
        )
    }

    function renderDeterminePIImportObjectDocumentType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="DocumentType"
                            margin="dense"
                            fullWidth={true}
                            id="DocumentType"
                            label="Object Document Type *"
                            onChange={(event) => {
                                changeHandler(event, "DocumentType", "DeterminePIImportObjectDocumentType");

                                documentTypeFormEnterpriseComponent.newQuery();
                                documentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                documentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                documentTypeFormEnterpriseComponent.executeQuery(1, 50);
                            }}
                            value={state.steps[0].controls["DocumentType"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {documentTypeBuffer.map((element: any) => (
                                <MenuItem key={element.USID} value={element.get("USID")}>
                                    {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                </div>
                {renderTransition("DeterminePIImportObjectDocumentType", state.steps[0].controls["DocumentType"].value)}
            </>
        )
    }

    function renderDetermineImportDocumentTypeForm() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="Form"
                            margin="dense"
                            fullWidth={true}
                            id="Form"
                            label="Form *"
                            onChange={(event) => {
                                changeHandler(event, "Form", "DetermineImportDocumentTypeForm")
                            }}
                            value={state.steps[0].controls["Form"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {formBuffer.map((element: any) => {
                                if (element.get("ListOfFormTemplate").FormTemplate.length > 0) {
                                    return (
                                        <MenuItem key={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID} value={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID}>
                                            {`${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DocumentID} Rev ${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DisplayRevision}`}
                                        </MenuItem>
                                    )
                                }
                            })}
                        </TextField>
                    )}
                </div>
                {renderTransition("DetermineImportDocumentTypeForm", state.steps[0].controls["Form"].value)}
            </>
        )
    }

    function renderDetermineARImportDocumentTypeForm() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    {documentTypeARFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                        <TextField
                            select
                            key="ARForm"
                            margin="dense"
                            fullWidth={true}
                            id="ARForm"
                            label="Approval Request Form *"
                            onChange={(event) => {
                                changeHandler(event, "ARForm", "DetermineARImportDocumentTypeForm")
                            }}
                            value={state.steps[0].controls["ARForm"].value}
                            variant="outlined"
                            slotProps={{
                                input: {},
                                inputLabel: {shrink: true}
                            }}>
                            {formBufferAR.map((element: any) => {
                                if (element.get("ListOfFormTemplate").FormTemplate.length > 0) {
                                    return (
                                        <MenuItem key={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID} value={element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevisionUSID}>
                                            {`${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DocumentID} Rev ${element.get("ListOfFormTemplate").FormTemplate[0].DocumentRevision.DisplayRevision}`}
                                        </MenuItem>
                                    )
                                }
                            })}
                        </TextField>
                    )}
                </div>
                {renderTransition("DetermineARImportDocumentTypeForm", state.steps[0].controls["ARForm"].value)}
            </>
        )
    }

    function renderSelectUploadSource() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="UploadSource"
                        margin="dense"
                        fullWidth={true}
                        id="Form"
                        label="Upload Source *"
                        onChange={(event) => {
                            changeHandler(event, "UploadSource", "DetermineUploadSource")
                        }}
                        value={state.steps[0].controls["UploadSource"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        <MenuItem key={"Local Disk"} value={"LOCAL_DISK"}>
                            Local Disk
                        </MenuItem>
                        <MenuItem key={"GoogleDrive"} value={"GOOGLE_DRIVE"}>
                            Google Drive
                        </MenuItem>
                        <MenuItem key={"DropBox"} value={"DROPBOX"}>
                            Dropbox
                        </MenuItem>
                        <MenuItem key={"S3"} value={"S3"}>
                            S3
                        </MenuItem>
                    </TextField>
                </div>
                {renderTransition("DetermineUploadSource", state.steps[0].controls["UploadSource"].value)}
            </>
        )
    }

    function renderImport_ImportEnlilObject_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons() {
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "0px 20px 20px 20px"}}>
                <div style={{marginRight: "20px"}}>
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={() => cancelHandler()}>
                        Cancel
                    </CCButton>
                </div>
                <div style={{marginRight: "10px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        animate={saveBackgroundOperation}
                        onClick={() => saveImportTemplateHandler("Save")}>
                        Save
                    </CCButton>
                </div>
                <div style={{marginRight: "10px"}}>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        animate={saveBackgroundOperation}
                        onClick={() => saveImportTemplateHandler("Analyze")}>
                        Analyze
                    </CCButton>
                </div>
                <CCButton
                    className={css_buttons.blueStandardButton}
                    animate={saveBackgroundOperation}
                    onClick={() => saveImportTemplateHandler("Execute")}>
                    Execute
                </CCButton>
            </div>
        )
    }


    function renderExecuteSubType() {
        let subTypeOptions = [
            "Enlil Service"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="SubType"
                        margin="dense"
                        fullWidth={true}
                        id="SubType"
                        label="Sub Type *"
                        onChange={(event) => changeHandler(event, "SubType", "ExecuteSubType")}
                        value={state.steps[0].controls["SubType"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {subTypeOptions.map(option => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ExecuteSubType", state.steps[0].controls["SubType"].value)}
            </>
        )
    }

    function renderExecuteEnlilService() {
        let objectOptions = [
            "Company Duplication"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="Object"
                        margin="dense"
                        fullWidth={true}
                        id="Object"
                        label="Object *"
                        onChange={(event) => changeHandler(event, "Object", "ExecuteEnlilService")}
                        value={state.steps[0].controls["Object"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {objectOptions.map(option => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("ExecuteEnlilService", state.steps[0].controls["Object"].value)}
            </>
        )
    }

    async function uploadImageToS3(file: File, type: 'logo' | 'avatar') {
        const sessionContext = new SessionContext();
        const s3Client = new S3Client({
            region: "us-west-2",
            credentials: {
                accessKeyId: sessionContext.getS3AccessKeyId()!,
                secretAccessKey: sessionContext.getS3SecretAccessKey()!,
                sessionToken: sessionContext.getS3SessionToken()!,
            },
        });

        const ext = file.name.split('.').pop()?.toLowerCase() ?? 'png';
        const key = `jobs/companyDuplication/${sessionContext.getRealm()}/${jobUSID}/${type}.${ext}`;
        const bucket = `enlil-${process.env.REACT_APP_ENLIL_ENV}-attachments-t1`;

        const setStatus = type === 'logo' ? setLogoUploadStatus : setAvatarUploadStatus;
        const setKey = type === 'logo' ? setLogoS3Key : setAvatarS3Key;

        setStatus('uploading');
        try {
            const upload = new Upload({
                client: s3Client,
                params: { Bucket: bucket, Key: key, Body: file, ContentType: file.type },
            });
            await upload.done();
            setKey(key);
            setStatus('done');
        } catch {
            setStatus('error');
        }
    }

    function renderImageUploadRow(
        label: string,
        file: File | null,
        setFile: (f: File | null) => void,
        uploadStatus: 'idle' | 'uploading' | 'done' | 'error',
        inputRef: React.RefObject<HTMLInputElement>,
        type: 'logo' | 'avatar',
    ) {
        const statusColor = uploadStatus === 'done' ? '#00A044' : uploadStatus === 'error' ? '#FF0000' : '#7B8291';
        const statusLabel = uploadStatus === 'done' ? 'Done' : uploadStatus === 'error' ? 'Error' : uploadStatus === 'uploading' ? 'Uploading...' : 'Ready';

        return (
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", margin: "0px 20px 20px 20px", padding: "8px 12px", border: "1px solid #BAC3CE", borderRadius: "5px", minHeight: "55px"}}>
                <IconButton
                    size="small"
                    disabled={uploadStatus === 'uploading'}
                    onClick={() => inputRef.current?.click()}
                    style={{marginRight: "12px"}}>
                    <CloudUpload style={{color: Grey6, width: "32px", height: "32px"}}/>
                </IconButton>
                <Typography style={{fontSize: "14px", fontWeight: 500, color: "#7B8291", minWidth: "120px"}}>{label}</Typography>
                {file && (
                    <>
                        <Typography style={{fontSize: "14px", fontWeight: 500, color: "#262837", marginLeft: "12px", flex: 1}}>{file.name}</Typography>
                        <Typography style={{fontSize: "14px", fontWeight: 500, color: statusColor, marginLeft: "12px"}}>{statusLabel}</Typography>
                    </>
                )}
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    aria-label={`Upload ${label}`}
                    style={{display: "none"}}
                    onChange={(e) => {
                        const f = e.target.files?.[0] ?? null;
                        if (f) {
                            setFile(f);
                            uploadImageToS3(f, type);
                        }
                        e.target.value = '';
                    }}
                />
            </div>
        );
    }

    function renderExecuteCompanyDuplication() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        key="CompanyName"
                        margin="dense"
                        fullWidth={true}
                        id="CompanyName"
                        label="Company Name *"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        variant="outlined"
                        slotProps={{inputLabel: {shrink: true}}}
                    />
                </div>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        key="Acronym"
                        margin="dense"
                        fullWidth={true}
                        id="Acronym"
                        label="Acronym *"
                        value={acronym}
                        onChange={(e) => setAcronym(e.target.value)}
                        variant="outlined"
                        slotProps={{inputLabel: {shrink: true}}}
                    />
                </div>
                {renderImageUploadRow("Logo", logoFile, setLogoFile, logoUploadStatus, logoInputRef, 'logo')}
                {renderImageUploadRow("Avatar", avatarFile, setAvatarFile, avatarUploadStatus, avatarInputRef, 'avatar')}
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "0px 20px 20px 20px"}}>
                    <div style={{marginRight: "20px"}}>
                        <CCButton
                            className={css_buttons.redStandardButton}
                            onClick={() => cancelHandler()}>
                            Cancel
                        </CCButton>
                    </div>
                    <div style={{marginRight: "10px"}}>
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            animate={saveBackgroundOperation}
                            onClick={() => saveExecuteCompanyDuplicationHandler("Save")}>
                            Save
                        </CCButton>
                    </div>
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        animate={saveBackgroundOperation}
                        onClick={() => saveExecuteCompanyDuplicationHandler("Execute")}>
                        Save & Execute
                    </CCButton>
                </div>
            </>
        )
    }

    function renderSelectEquipmentDownloadVolume() {
        let options = [
            "1+ Equipment Objects",
            "All Equipment Objects"
        ]

        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="DownloadVolume"
                        margin="dense"
                        fullWidth={true}
                        id="DownloadVolume"
                        label="Download Volume *"
                        onChange={(event) => changeHandler(event, "DownloadVolume", "SelectEquipmentDownloadVolume")}
                        value={state.steps[0].controls["DownloadVolume"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        {options.map(option => (
                            <MenuItem key={option} value={option.toUpperCase()}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                {renderTransition("SelectEquipmentDownloadVolume", state.steps[0].controls["DownloadVolume"].value)}
            </>
        )
    }

    function formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    function renderUploadSpreadsheetFromLocalDisk() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "7px 20px 20px 20px", paddingLeft: "5px", border: "1px solid #BAC3CE", borderRadius: "5px", height: "55px"}}>
                    <IconButton
                        className={css_buttons.whiteStandardButton} style={{marginLeft: "0px", marginTop: "7px", cursor: "pointer"}} size="small"
                        onClick={() => {
                            setShowUploadSpreadsheet(true)
                        }}>
                        <Backup style={{color: Grey6, width: "40px", height: "40px"}}/>
                    </IconButton>
                    {selectedFiles.map((file: any, index) => (
                        <div key={index } style={{display: "flex", flexDirection: "column", marginTop: "6px", marginRight: "20px"}}>
                            <div key={file.name + index} style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <div key={file.name + index} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "500px"}}>
                                    <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                        <div style={{width: "33px", height: "33px", backgroundColor: "#EDEFF3", borderRadius: "5px", margin: "5px 5px 5px 10px"}}>
                                            <TextSnippet sx={{color: "#A8A9AF", width: "18px", height: "18px", marginTop: "7px", marginLeft: "8px"}}/>
                                        </div>
                                        <div style={{display: "flex", flexDirection: "column"}}>
                                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "3px"}}>
                                                <Typography style={{fontSize: "14px", fontWeight: 500, color: "#262837"}}>{file.name}</Typography>
                                            </div>
                                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "-3px"}}>
                                                <Typography style={{fontFamily: "courier", fontSize: "13px", fontWeight: 400, color: "#262837"}}>{formatFileSize(file.size)}</Typography>
                                                <Typography style={{fontFamily: "courier", fontSize: "13px", fontWeight: 400, color: "#262837"}}>&nbsp;&#183;&nbsp;</Typography>
                                                <Typography style={{fontSize: "14px", fontWeight: 500, color: "#00A044"}}>Done</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {renderTransition("UploadSpreadsheetFromLocalDisk", selectedFiles.length > 0 ? "True" : "")}
            </>
        )
    }

    function renderTransition(directive: string, selection: string): any {
        if (selection === "") return null;

        // @ts-ignore
        let transition = transitions[directive][selection];
        if (transition === undefined) {
            selection = "ANY"
            // @ts-ignore
            transition = transitions[directive][selection];
        }

        // Safety check: if transition is still undefined, the directive/selection doesn't exist
        if (transition === undefined) return null;

        let r = null;
        if (directive === "DetermineImportDocumentTypeForm" && breadcrumb.get("ImportEnlilObject") === "PART") {
            r = transitions["DetermineARImportObjectDocumentType"]["Renderer"]
        } else if (directive === "DetermineImportDocumentTypeForm" && breadcrumb.get("ImportEnlilObject") === "EQUIPMENT_SPECIFICATION") {
            r = transitions["DetermineARImportObjectDocumentType"]["Renderer"]
        } else {
            // @ts-ignore
            const nextStateObj = transitions[transition];
            if (nextStateObj) {
                r = nextStateObj["Renderer"];
            }
        }

        // Safety check: if renderer is not found, return null
        if (!r) return null;

        // @ts-ignore
        return funcs[r]();
    }

    function renderType() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", margin: "0px 20px 20px 20px"}}>
                    <TextField
                        select
                        key="Type"
                        margin="dense"
                        fullWidth={true}
                        id="Type"
                        label="Type *"
                        onChange={(event) => {
                            changeHandler(event, "Type", "Type")
                        }}
                        value={state.steps[0].controls["Type"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}>
                        <MenuItem key={1} value="Execute">
                            Execute
                        </MenuItem>
                        <MenuItem key={2} value="Import">
                            Import
                        </MenuItem>
                        <MenuItem key={3} value="Export">
                            Export
                        </MenuItem>
                    </TextField>
                </div>
                {renderTransition("Type", state.steps[0].controls["Type"].value)}
            </>
        )
    }

    function render() {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 20px"}}>
                    <TextField
                        key="Name"
                        margin="dense"
                        fullWidth={true}
                        helperText={"Job name must be 1-128 characters. The first character must be alphanumeric. Valid characters are a-z, A-Z, 0-9, hyphens (-), and underscores (_)."}
                        id="Name"
                        label="Name *"
                        onChange={(event) => changeHandler(event, "Name", "Name")}
                        value={state.steps[0].controls["Name"].value}
                        variant="outlined"
                        slotProps={{
                            input: {},
                            inputLabel: {shrink: true}
                        }}
                    />
                </div>
                {state.steps[0].controls["Name"].value !== "" ? renderType() : null}
            </div>
        )
    }

    function saveImportTemplateHandler(action: string) {
        let sessionContext = new SessionContext();

        etlJobEnterpriseComponent.newRecord();
        etlJobEnterpriseComponent.setAttributeValue("USID",  jobUSID)
        etlJobEnterpriseComponent.setAttributeValue("Name",  state.steps[0].controls["Name"].value)
        etlJobEnterpriseComponent.setAttributeValue("Type",  state.steps[0].controls["Type"].value)
        etlJobEnterpriseComponent.setAttributeValue("SubType",  state.steps[0].controls["SubType"].value)
        let specification = {
            "Action": action,
            "Object": state.steps[0].controls["Object"].value,
            "Spreadsheet": "jobs/" + sessionContext.getRealm() + "/" + jobUSID + "/" + state.steps[0].controls["Object"].value.toLowerCase() + ".xlsx",
            "UploadSource": "Local Disk",
            "DocumentTypeUSID": state.steps[0].controls["DocumentType"].value,
            "FormDocumentRevisionUSID": state.steps[0].controls["Form"].value,
            "ARDocumentTypeUSID": state.steps[0].controls["ARDocumentType"].value,
            "ARFormDocumentRevisionUSID": state.steps[0].controls["ARForm"].value
        }
        etlJobEnterpriseComponent.setAttributeValue("Specification", btoa(JSON.stringify(specification)))
        etlJobEnterpriseComponent.executeInsert();
        setSaveBackgroundOperation(false)
        navigate("/jobs");
    }

    function saveExportTemplateHandler(action: string) {
        etlJobEnterpriseComponent.newRecord();
        etlJobEnterpriseComponent.setAttributeValue("USID",  jobUSID)
        etlJobEnterpriseComponent.setAttributeValue("Name",  state.steps[0].controls["Name"].value)
        etlJobEnterpriseComponent.setAttributeValue("Type",  state.steps[0].controls["Type"].value)
        etlJobEnterpriseComponent.setAttributeValue("SubType",  state.steps[0].controls["SubType"].value)
        let specification = {
            "Action": action,
            "Object": state.steps[0].controls["Object"].value,
            "DocumentTypeUSID": state.steps[0].controls["DocumentType"].value,
            "FormDocumentRevisionUSID": state.steps[0].controls["Form"].value
        }
        etlJobEnterpriseComponent.setAttributeValue("Specification", btoa(JSON.stringify(specification)))
        etlJobEnterpriseComponent.executeInsert();
        setSaveBackgroundOperation(false)
        navigate("/jobs");
    }

    function saveExportEquipmentTemplateHandler(action: string) {
        etlJobEnterpriseComponent.newRecord();
        etlJobEnterpriseComponent.setAttributeValue("USID",  jobUSID)
        etlJobEnterpriseComponent.setAttributeValue("Name",  state.steps[0].controls["Name"].value)
        etlJobEnterpriseComponent.setAttributeValue("Type",  state.steps[0].controls["Type"].value)
        etlJobEnterpriseComponent.setAttributeValue("SubType",  state.steps[0].controls["SubType"].value)
        let specification = {
            "Action": action,
            "Object": state.steps[0].controls["Object"].value,
            "DocumentTypeUSID": state.steps[0].controls["DocumentType"].value,
            "FormDocumentRevisionUSID": state.steps[0].controls["Form"].value,
            "CalibrationDocumentTypeUSID": state.steps[0].controls["CalibrationDocumentType"].value,
            "PreventativeMaintenanceDocumentTypeUSID": state.steps[0].controls["PreventativeMaintenanceDocumentType"].value,
        }
        etlJobEnterpriseComponent.setAttributeValue("Specification", btoa(JSON.stringify(specification)))
        etlJobEnterpriseComponent.executeInsert();
        setSaveBackgroundOperation(false)
        navigate("/jobs");
    }

    function saveExecuteCompanyDuplicationHandler(action: string) {
        let sessionContext = new SessionContext();
        
        etlJobEnterpriseComponent.newRecord();
        etlJobEnterpriseComponent.setAttributeValue("USID",  jobUSID)
        etlJobEnterpriseComponent.setAttributeValue("Name",  state.steps[0].controls["Name"].value)
        etlJobEnterpriseComponent.setAttributeValue("Type",  state.steps[0].controls["Type"].value)
        etlJobEnterpriseComponent.setAttributeValue("SubType",  state.steps[0].controls["SubType"].value)
        let specification = {
            "Action": action,
            "Object": state.steps[0].controls["Object"].value.toUpperCase(),
            "CompanyUSID": sessionContext.getRealm(),
            "Realm": sessionContext.getRealm(),
            "EmployeeUSID": sessionContext.getEmployeeUSID(),
            "CompanyName": companyName,
            "Acronym": acronym,
            "LogoS3Key": logoS3Key,
            "AvatarS3Key": avatarS3Key,
        }
        etlJobEnterpriseComponent.setAttributeValue("Specification", btoa(JSON.stringify(specification)))
        etlJobEnterpriseComponent.executeInsert();
        setSaveBackgroundOperation(false)
        navigate("/jobs");
    }

    var funcs = {
        renderImportSubType, renderExportSubType, renderExecuteSubType,

        renderImportEnlilObject,
        renderDetermineImportObjectDocumentType,
        renderDetermineImportDocumentTypeForm,
        renderDeterminePIImportObjectDocumentType,
        renderSelectUploadSource,
        renderUploadSpreadsheetFromLocalDisk,
        renderImport_ImportEnlilObject_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons,

        renderExport_ExportEnlilTemplate,
        renderExportEnlilObject,
        renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType,
        renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm,
        renderExport_ExportEnlilTemplate_Object_DetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons,

        renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType,
        renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm,
        renderExport_ExportEnlilTemplate_Object_EquipmentCalibration_DetermineObjectDocumentType,
        renderExport_ExportEnlilTemplate_Object_EquipmentPreventativeMaintenance_DetermineObjectDocumentType,
        renderExport_ExportEnlilTemplate_Object_EquipmentDetermineObjectDocumentType_DetermineExportDocumentTypeForm_CreateJobButtons,

        renderExport_ExportEnlilTemplate_Object_PIDetermineObjectDocumentType,

        renderSelectEquipmentDownloadVolume,
        renderDetermineARImportObjectDocumentType,
        renderDetermineARImportDocumentTypeForm,
        renderExecuteEnlilService,
        renderExecuteCompanyDuplication
    }

    return (
        <>
            {showUploadSpreadsheet ? <UploadSpreadsheet jobUSID={jobUSID}/> : null}
            <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                    <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                        <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Jobs</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", padding: "15px 20px 20px 20px", width: "700px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: 52, backgroundColor: "#FFFFFF"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "7px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                setShowUploadSpreadsheet(true);
                            }}>
                            <KeyboardBackspace sx={{color: "#021EBB", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <div style={{display: "flex", flexDirection: "row", paddingTop: "11px"}}>
                            <Typography style={{fontSize: 22, fontWeight: 500, color: "#1498D8"}}>Create Job</Typography>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: "0px", backgroundColor: "#FFFFFF", border: "1px solid #EDEFF3", borderRadius: "20px"}}>
                        {render()}
                    </div>
                </div>
            </div>
        </>
    );

}